import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import { Icon } from '../../node_modules/@flixbus/honeycomb-icons-react/dist/esm/components/icon/icon.js';

/**
 * Creates an Icon using the provided InlineIcon according to active state.
 * @param InlineIcon
 * @param {boolean} active the active flag to choose an icon.
 * @returns {JSXElement} The DOM node to use as the Portal target.
 */
var useInlineIcon = function (InlineIcon, active, iconRest) {
  var _a;
  if (!InlineIcon) return null;
  var iconComp = InlineIcon;
  if ((_a = iconComp.displayName) === null || _a === void 0 ? void 0 : _a.includes('InlineIcon')) {
    return /*#__PURE__*/React__default__default.createElement(Icon, __assign({}, iconRest, {
      InlineIcon: iconComp,
      "aria-hidden": "true"
    }));
  }
  var inlineIconAsObj = InlineIcon;
  var computedIcon = active ? inlineIconAsObj.active : inlineIconAsObj.regular;
  return /*#__PURE__*/React__default__default.createElement(Icon, __assign({}, iconRest, {
    InlineIcon: computedIcon,
    "aria-hidden": "true"
  }));
};
var InlineIconPropType = PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.shape({
  regular: PropTypes__default.func.isRequired,
  active: PropTypes__default.func.isRequired
})]);

export { InlineIconPropType, useInlineIcon as default };
